import { HttpService } from "@/core";
import {
  DictReq,
  DictPageReq,
  DictPageResp,
  DictDetailResp,
  DictGroupListResp,
  DictValRecord,
} from "./dict.interface";
import { message } from "ant-design-vue";
import { AxiosResponse } from "axios";
import { ResponseResp } from "@/core/interface";

const dictCacheMap = new Map();

export class DictService {
  static usePageApi() {
    const api = (params: DictPageReq) =>
      HttpService.axios({
        method: "GET",
        url: "/tenant_dict/page",
        params,
      });
    return HttpService.usePagination<DictPageResp>(api);
  }

  static async fetchOptionsByDictCode(dictCode: string): Promise<DictValRecord[]> {
    // const cached = dictCacheMap.get(dictCode);
    // if (dictCacheMap.get(dictCode)) {
    //   return cached;
    // }
    let options: DictValRecord[] = [];
    try {
      const r: AxiosResponse<ResponseResp<DictGroupListResp>> = await HttpService.axios({
        method: "GET",
        url: "/tenant_dict/groupList",
        params: {
          dictCodes: dictCode,
        },
      });
      const res = r.data;
      if (res.respCode !== "0000") {
        message.error(res.respDesc);
        return options;
      }
      if (res.data.records.length === 1) {
        options = res.data.records[0].list;
        dictCacheMap.set(dictCode, options);
      }
    } catch (e: any) {
      message.error(e.message);
    }
    return options;
  }

  static useDetailApi() {
    const api = (id: string) =>
      HttpService.axios({
        method: "GET",
        url: `/tenant_dict/${id}`,
      });
    return HttpService.useRequest<DictDetailResp>(api);
  }

  static useCreateApi() {
    const api = (data: DictReq) =>
      HttpService.axios({
        method: "POST",
        url: "/tenant_dict",
        data,
      });
    return HttpService.useRequest<void>(api);
  }

  static useEditApi() {
    const api = (id: string, data: DictReq) =>
      HttpService.axios({
        method: "PUT",
        url: `/tenant_dict/${id}`,
        data,
      });
    return HttpService.useRequest<void>(api);
  }

  static useDeleteApi() {
    const api = (id: string) =>
      HttpService.axios({
        method: "DELETE",
        url: `/tenant_dict/${id}`,
      });
    return HttpService.useRequest<void>(api);
  }
}
